import { ApiService } from "core/services";

class DataProcessingApi extends ApiService {
  constructor() {
    super("data-processing");
  }

  getDataProcessingSetting() {
    return this.get("");
  }

  addDataProcessingSetting(payload) {
    return this.post("", payload);
  }

  updateDataProcessingSetting(payload) {
    return this.put(`${payload.id}`, { form_edition: payload.form_edition, setting_body: payload.setting_body });
  }
}

export default DataProcessingApi;
